/**
 * wechatSignOperationBtnsModule
 * description: wechat渠道下操作按钮
 * author: Qian.qianchen 2019-03-26
 */
'use strict';
angular.module('wechatSignOperationBtnsModule', []).directive('wechatSignOperationBtns', ['modalDialog', 'trsHttpService', 'sensitiveWordCheckService', 'trsspliceString', function (modalDialog, trsHttpService, sensitiveWordCheckService, trsspliceString) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionSign/directive/wechatSignOperationBtns/wechatSignOperationBtns_tpl.html',
        scope: {
            selectedArr: '=',
            callback: '&'
        },
        link: function ($scope, iElement, attrs) {
            initStatus();

            function initStatus() {
                $scope.status = {
                    signedSuccess: false
                };
            }

            /**
             * [sign description] 送签
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.sign = function () {
                var chnldocIDs = trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ',');
                var queryTitleContent = true;
                var queryShenKanQianFa = trsspliceString.spliceString($scope.selectedArr, 'CLIENTEXAMINE', ',');
                if (queryShenKanQianFa.indexOf('0') == -1) {
                    queryTitleContent = false;
                }
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 4, queryTitleContent).then(function () {
                    $scope.status.signedSuccess = true;
                    sign(chnldocIDs);
                }, function () {
                    modalDialog.confirmModal('送签', '确认发送该稿件到待签平台?', function () {
                        $scope.status.signedSuccess = true;
                        sign(chnldocIDs);
                    });
                });
            };

            /**
             * [sign description] 送签
             * @param  {[type]} chnldocIDs [description]
             * @return {[type]}            [description]
             */
            function sign(chnldocIDs) {
                var params = {
                    serviceid: 'mlf_wechatoper',
                    methodname: 'webDaiShenPublish',
                    ObjectIds: chnldocIDs,
                    ChnlDocIds: chnldocIDs
                };
                var metaDataIds = trsspliceString.spliceString($scope.selectedArr, 'METADATAID', ',');
                $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('送签成功', '', 'success', false, function () {
                        $scope.callback();
                    });
                    // if ($scope.status.signedSuccess) {
                    //     modalDialog.multiReportsAlert(data, '');
                    //     $scope.callback();
                    // } else {
                    //     modalDialog.alertType('送签成功', '', 'success', false, function () {
                    //         $scope.callback();
                    //     });
                    // }
                    $scope.status.signedSuccess = false;
                }, function () {
                    $scope.callback();
                    $scope.status.signedSuccess = false;
                });
                // signPush(metaDataIds);
            }

            /**
             * [lookSigned 审看送签]
             * @return {[type]} [description]
             */
            $scope.lookSigned = function () {
                var queryTitleContent = true;
                var queryShenKanQianFa = trsspliceString.spliceString($scope.selectedArr, 'CLIENTEXAMINE', ',');
                var ChnlDocIds = trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ',');
                if (queryShenKanQianFa.indexOf('1') == -1) {
                    modalDialog.alertType('未同意送签的稿件不允许审看送签', '', 'error', 'confirm', function () { });
                    return;
                }
                // 如果稿件全部带审看权限,直接送签,不填写提示内容
                if (queryShenKanQianFa.indexOf('0') == -1) {
                    queryTitleContent = false;
                }
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.selectedArr, '', 4, queryTitleContent).then(function () {
                    $scope.status.signedSuccess = true;
                    lookatSigned(ChnlDocIds);
                }, function () {
                    modalDialog.confirmModal('送签', '确认发送该稿件到待签平台?', function () {
                        $scope.status.signedSuccess = true;
                        lookatSigned(ChnlDocIds);
                    });
                });
            };

            /**
             * [lookatSigned 审看送签]
             * @return {[type]} [description]
             */
            function lookatSigned(item) {
                var params = {
                    serviceid: 'mlf_wechatoper',
                    methodname: 'weChatDaiShenKanShenPublish',
                    ChnlDocIds: item
                };
                $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    if ($scope.status.signedSuccess) {
                        modalDialog.multiReportsAlert(data, '');
                        $scope.callback();
                    } else {
                        modalDialog.alertType('审看送签成功', '', 'success', false, function () {
                            $scope.callback();
                        });
                    }
                    $scope.status.signedSuccess = false;
                }, function () {
                    $scope.callback();
                    $scope.status.signedSuccess = false;
                });
            }

            /**
             * [rejectionDraft description] 撤稿
             */
            $scope.rejectionDraft = function () {
                modalDialog.inputModel('是否确认撤稿', '撤稿原因(可选)', function (content) {
                    rejection(content);
                });
            };

            /**
             * [rejection description] 退稿方法
             */
            function rejection(Opinion) {
                var params = {
                    'serviceid': 'mlf_wechatoper',
                    'methodname': 'rejectionMetaDatas',
                    'ChannelId': $scope.selectedArr[0].CHNLID, // 微信都一样的,所以取选中的第一条的CHNLID
                    'Opinion': Opinion,
                    'ChnlDocIds': trsspliceString.spliceString($scope.selectedArr, 'CHNLDOCID', ','),
                    'metaDataIds': trsspliceString.spliceString($scope.selectedArr, 'METADATAID', ','),
                };
                promptRequest(params, '撤稿成功');
            }

            /**
             * [promptRequest description]具体操作数据请求成功后刷新列表
             * @param  {[obj]} params [description]请求参数
             * @param  {[string]} info   [description]提示语
             * @return {[type]}        [description]
             */
            function promptRequest(params, info) {
                $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    modalDialog.alertType(info, '', 'success', false, function () {
                        $scope.callback();
                    });
                });
            }
        }
    };
}]);
